import { uniqueId } from "lodash"
import NotificationService from "@/services/NotificationService"

// Load default storage values from app.config file
import config from "@/app.config"
import { getTimeZoneName } from "@/utils/datetime"

const module = {
  namespaced: true,
  state: {
    locale: config.plugins.i18n.locale,
    isThemeDark: config.plugins.vuetify.theme.dark,
    languages: [
      { language: "Deutsch", short: "de" },
      { language: "English", short: "en" },
      { language: "Español", short: "es" },
      { language: "Français", short: "fr" },
      { language: "Italiano", short: "it" },
      { language: "中文", short: "cn" }
    ],
    errors: [],
    isOnline: true,
    user: null,
    project: null,
    pcqLiner: null,
    company: null,
    loading: {
      request: false
    },
    notifications: []
  },
  actions: {
    async fetchNotifications(context) {
      return NotificationService.list(null).then(r => {
        context.commit("setNotifications", r || [])
      })
    },
    async updateNotifications(context) {
      return NotificationService.markRead().then(r => {
        context.commit("setNotifications", r || [])
      })
    }
  },
  getters: {
    getCompany(state) {
      return state.company ? state.company : -1
    },
    getLocale(state) {
      return state.locale
    },
    getNewNotifications(state) {
      return state.notifications.filter(e => !e.read)
    },
    isUserAdmin(state) {
      return state.user?.admin
    },
    isCompanyOwner(state) {
      return state.user?.is_company_owner
    },
    isSignedIn(state) {
      return state.user != null
    },
    canCreateProject(state) {
      return state.user?.can_create_project
    },
    hasSelectedProject(state) {
      return !!state.project
    },
    isUserStaff(state) {
      return state.user?.is_staff
    }
  },
  mutations: {
    clearSession(state) {
      Object.assign(state, {
        errors: [],
        isOnline: true,
        user: null,
        project: null,
        pcqLiner: null,
        company: null,
        loading: {
          request: false
        },
        notifications: []
      })
    },
    setLocale(state, newValue) {
      state.locale = newValue
    },
    setIsThemeDark(state, newValue) {
      state.isThemeDark = newValue
    },
    setUser(state, newValue) {
      state.user = { ...newValue, tzName: getTimeZoneName() }
    },
    setProject(state, newValue) {
      state.project = newValue
    },
    setPcqLiner(state, newValue) {
      state.pcqLiner = newValue
    },
    clearPcqLiner(state) {
      state.pcqLiner = null
    },
    setCompany(state, newValue) {
      state.company = newValue
    },
    clearProject(state) {
      state.project = null
    },
    lockExtraFields(state) {
      if (state.project) {
        state.project.extra_fields_locked = true
      }
    },
    setNotifications(state, newValue) {
      state.notifications = newValue
    },
    clearMessages(state) {
      state.errors = []
    },
    message(state, ml) {
      if (ml)
        state.errors.push({
          id: uniqueId(),
          text: ml.msg ?? "No message notification",
          color: ml.color,
          isVisible: true,
          createdAt: new Date().getTime(),
          timeout: ml.timeout ?? 3000
        })
    },
    success(state, msg) {
      state.errors.push({
        id: uniqueId(),
        text: msg,
        color: "success",
        isVisible: true,
        createdAt: new Date().getTime(),
        timeout: 3000
      })
    },
    online(state) {
      state.isOnline = true
    },
    offline(state) {
      state.isOnline = false
    },
    "loading-request-start": state => {
      state.loading.request = true
    },
    "loading-request-end": state => {
      state.loading.request = false
    },
    updateProjectValidation(state, payload) {
      state.project.validated_pcq_dsi = payload.validated_pcq_dsi
    },
    updatePcqLinerValidation(state, payload) {
      state.pcqLiner.validated = payload.validated
    }
  }
}

export default module
